import { combineReducers } from "redux";
import * as Form from 'react-redux-form';
import { initialOrderHdListingsForm, pathsOrderHdListingsForm } from "products/orderHdListings/OrderHdListings";
export const orderHdListingsReducer = combineReducers({
    orderForm: Form.modelReducer('products.orderHdListings.orderForm', initialOrderHdListingsForm),
    orderFormState: Form.formReducer('products.orderHdListings.orderForm', initialOrderHdListingsForm)
});
//-- Populate path names for Forms
export const configureFormStrings = (orderFormState) => {
    try {
        const pathOrderHdListings = orderFormState.orderFormState.$form.model;
        pathsOrderHdListingsForm.modelPath = pathOrderHdListings;
        Object.keys(orderFormState.orderForm).map((key) => {
            pathsOrderHdListingsForm[key] = `${pathOrderHdListings}.${key}`;
        });
    }
    catch (err) {
        console.log("Error mapping Form Path names. Please fix.", err);
    }
};
